export const TOO_MANY_USERS_REASON = 'Too many users';
export const ROOM_INACTIVE_REASON = 'Room deactivated';
export const EXCLUDED_REASON = 'Excluded';
export const BLOCKED_REASON = 'Blocked';
export const BLACKLISTED_REASON = 'Blacklisted';
export const NONEXISTENT_ROOM_REASON = 'No such room';
export const ANONYMOUS_NICK_ALREADY_EXISTS = 'User with such nick already exists';
export const INVALID_GENDER_REASON = 'InvalidGender';
export const PAYMENT_REQUIRED = 'Payment required';
export const INSUFFICIENT_FUNDS = 'Insufficient funds';



// WEBPACK FOOTER //
// ./src/constants/chatInterface.js